window.initSwiper = function(container) {
    const swiperElement = typeof container === 'string'
        ? document.querySelector(container)
        : container;

    if (!swiperElement) {
        return;
    }

    const paginationElement = swiperElement.querySelector('.swiper-pagination');

    new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 600,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        pagination: {
            el: paginationElement,
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 20
            }
        }
    });
}
